import { gql } from "graphql-request";
const REFRESH_TOKEN = gql`
    query refreshToken($accessToken: String!) {
      refreshToken(accessToken: $accessToken) {
        accessToken
        refreshToken
      }
    }
  `;

export default REFRESH_TOKEN;